<template>
  	<FlexEditReseller />
</template>

<script>

// @ is an alias to /src
import FlexEditReseller from "@/components/EditReseller.vue";

export default {
  name: "FlexEditResellers",
  components: {
    FlexEditReseller,
  },
};
</script>
